//REVIEW: change to datePicker
import {
  Component,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  OnInit,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  Renderer2,
  ViewChild,
  TemplateRef,
  ContentChildren,
  QueryList
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { LocaleSettings } from 'primeng/calendar';

let rcCalendarZIndex = 1000;

export const RCCALENDAR_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RcCalendarComponent),
  multi: true
};

@Component({
  selector: 'rc-calendar',
  templateUrl: './rc-calendar.component.html',
  host: {
    '[class.ui-inputwrapper-filled]': 'filled',
    '[class.ui-inputwrapper-focus]': 'focus'
  },
  providers: [RCCALENDAR_VALUE_ACCESSOR]
})
export class RcCalendarComponent
  implements AfterViewInit,
    OnInit,
    OnDestroy,
    ControlValueAccessor {
  @Input() defaultDate: Date;

  @Input() style: string;

  @Input() styleClass: string;

  @Input() inputStyle: string;

  @Input() inputId: string;

  @Input() name: string;

  @Input() inputStyleClass: string;

  @Input() placeholder: string;

  @Input() disabled: any;

  @Input() dateFormat: string = 'mm/dd/yy';

  @Input() inline: boolean = false;

  @Input() showOtherMonths: boolean = true;

  @Input() showOnlyFirstSelection: boolean = false;

  @Input() selectOtherMonths: boolean;

  @Input() differentStyleForMultiple: boolean = false;

  @Input() showIcon: boolean;

  @Input() icon: string = 'calendar-alt-icon';

  @Input() appendTo: any;

  @Input() shortYearCutoff: any = '+10';

  @Input() monthNavigator: boolean;

  @Input() yearNavigator: boolean;

  @Input() yearRange: string;

  @Input() hourFormat: string = '24';

  @Input() timeOnly: boolean;

  @Input() stepHour: number = 1;

  @Input() stepMinute: number = 1;

  @Input() stepSecond: number = 1;

  @Input() showSeconds: boolean = false;

  @Input() required: boolean;

  @Input() showOnFocus: boolean = true;

  @Input() dataType: string = 'date';

  @Input() utc: boolean;

  @Input() selectionMode: string = 'single';

  @Input() maxDateCount: number;

  @Input() showButtonBar: boolean;

  @Input() todayButtonStyleClass: string = 'ui-button-secondary';

  @Input() clearButtonStyleClass: string = 'ui-button-secondary';

  @Input() autoZIndex: boolean = true;

  @Input() baseZIndex: number = 0;

  @Input() panelStyleClass: string;


  @Output() onFocus: EventEmitter<any> = new EventEmitter();

  @Output() onBlur: EventEmitter<any> = new EventEmitter();

  @Output() onClose: EventEmitter<any> = new EventEmitter();

  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  @Output() onInput: EventEmitter<any> = new EventEmitter();

  @Output() onTodayClick: EventEmitter<any> = new EventEmitter();

  @Output() onClearClick: EventEmitter<any> = new EventEmitter();

  @Output() onMonthChange: EventEmitter<any> = new EventEmitter();

  @ContentChildren(TemplateRef) templates: QueryList<TemplateRef<any>>;

  _locale: LocaleSettings = {
    firstDayOfWeek: 0,
    dayNames: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    monthNamesShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ],
    today: 'Today',
    clear: 'Clear'
  };

  @Input() tabindex: number;

  @ViewChild('datepicker') overlayViewChild: ElementRef;

  @ViewChild('inputfield') inputfieldViewChild: ElementRef;

  value: any;

  dates: any[];

  weekDays: string[];

  quarters: any[];

  decade: any[];

  currentMonthText: string;

  currentMonth: number;

  currentYear: number;

  currentDecadeStart: number;

  currentDecadeEnd: number;

  showDays: boolean;

  showMonths: boolean;

  showYears: boolean;

  // currentHour: number;

  // currentMinute: number;

  // currentSecond: number;

  // pm: boolean;

  overlay: HTMLDivElement;

  overlayVisible: boolean = false;

  datepickerClick: boolean;

  onModelChange: Function = () => {};

  onModelTouched: Function = () => {};

  calendarElement: any;

  documentClickListener: any;

  ticksTo1970: number;

  yearOptions: number[];

  focus: boolean;

  isKeydown: boolean;

  filled: boolean;

  inputFieldValue: string = null;

  _minDate: Date;

  _maxDate: Date;

  _showTime: boolean;

  preventDocumentListener: boolean;

  dateTemplate: TemplateRef<any>;

  _disabledDates: Array<Date>;

  _disabledDays: Array<number>;

  @Input()
  get minDate(): Date {
    return this._minDate;
  }

  set minDate(date: Date) {
    this._minDate = date;
    if (this.currentMonth && this.currentYear) {
      this.createMonth(this.currentMonth, this.currentYear);
    }
  }
  @Input()
  get maxDate(): Date {
    return this._maxDate;
  }

  set maxDate(date: Date) {
    this._maxDate = date;
    if (this.currentMonth && this.currentYear) {
      this.createMonth(this.currentMonth, this.currentYear);
    }
  }

  @Input()
  get disabledDates(): Date[] {
    return this._disabledDates;
  }

  set disabledDates(disabledDates: Date[]) {
    this._disabledDates = disabledDates;
    if (this.currentMonth && this.currentYear) {
      this.createMonth(this.currentMonth, this.currentYear);
    }
  }

  @Input()
  get disabledDays(): number[] {
    return this._disabledDays;
  }

  set disabledDays(disabledDays: number[]) {
    this._disabledDays = disabledDays;
    if (this.currentMonth && this.currentYear) {
      this.createMonth(this.currentMonth, this.currentYear);
    }
  }

  get locale() {
    return this._locale;
  }

  @Input()
  set locale(newLocale: LocaleSettings) {
    this._locale = newLocale;
    this.createWeekDays();
    this.createMonth(this.currentMonth, this.currentYear);
  }

  constructor(
    public el: ElementRef,
    public renderer: Renderer2
  ) {}

  ngOnInit() {
    let date = this.defaultDate || new Date();
    this.createWeekDays();
    this.showDays = true;
    this.currentMonth = date.getMonth();
    this.currentYear = date.getFullYear();
    this.currentDecadeStart = this.currentYear - this.currentYear % 10;
    this.currentDecadeEnd = this.currentYear + (10 - this.currentYear % 10);

    this.createMonth(this.currentMonth, this.currentYear);
    this.createYear(this.currentYear);
    this.createDecades();

    this.ticksTo1970 =
      ((1970 - 1) * 365 +
        Math.floor(1970 / 4) -
        Math.floor(1970 / 100) +
        Math.floor(1970 / 400)) *
      24 *
      60 *
      60 *
      10000000;

    if (this.yearNavigator && this.yearRange) {
      this.yearOptions = [];
      let years = this.yearRange.split(':'),
        yearStart = parseInt(years[0]),
        yearEnd = parseInt(years[1]);

      for (let i = yearStart; i <= yearEnd; i++) {
        this.yearOptions.push(i);
      }
    }
  }

  ngAfterViewInit() {
    if (!this.inline && this.appendTo) {
      const appendTarget = this.getAppendTarget();

      if (appendTarget) {
        appendTarget.appendChild(this.overlayViewChild.nativeElement);
      }
    }
  }

  showMonthCalendar() {
    this.showMonths = true;
    this.showYears = false;
    this.showDays = false;
  }

  showYearCalendar() {
    this.showYears = true;
    this.showMonths = false;
    this.showDays = false;
  }

  getMonths(months) {

    return months[0];
  }

  ngAfterContentInit() {
    this.dateTemplate = this.templates.first || null;
  }

  createYear(year: number) {
    this.quarters = [];
    let today = new Date();
    let months = [];

    for (let i = 0; i < 12; i++) {
      months.push({
        month: this._locale.monthNamesShort[i],
        isCurrent:
          today.getMonth() === i && today.getFullYear() === this.currentYear,
        isSelected: year === this.currentYear && this.currentMonth === i
      });

      if ((i + 1) % 4 == 0) {
        this.quarters.push(months);
        months = [];
      }
    }
  }

  createDecades() {
    this.decade = [];
    let today = new Date();
    let years = [];
    for (let i = 0; i < 12; i++) {
      years.push({
        year: this.currentDecadeStart + i - 1,
        selectable: i > 0 && i < 11,
        isCurrent: today.getFullYear() === this.currentDecadeStart + i - 1,
        isSelected: this.currentDecadeStart + i - 1 === this.currentYear
      });

      if ((i + 1) % 4 == 0) {
        this.decade.push(years);
        years = [];
      }
    }
  }

  createWeekDays() {
    this.weekDays = [];
    let dayIndex = this.locale.firstDayOfWeek;
    for (let i = 0; i < 7; i++) {
      this.weekDays.push(this.locale.dayNamesMin[dayIndex]);
      dayIndex = dayIndex == 6 ? 0 : ++dayIndex;
    }
  }

  createMonth(month: number, year: number) {
    this.dates = [];
    this.currentMonth = month;
    this.currentYear = year;
    this.currentMonthText = this.locale.monthNames[month];
    let firstDay = this.getFirstDayOfMonthIndex(month, year);
    let daysLength = this.getDaysCountInMonth(month, year);
    let prevMonthDaysLength = this.getDaysCountInPrevMonth(month, year);
    let sundayIndex = this.getSundayIndex();
    let dayNo = 1;
    let today = new Date();

    for (let i = 0; i < 6; i++) {
      let week = [];

      if (i == 0) {
        for (
          let j = prevMonthDaysLength - firstDay + 1;
          j <= prevMonthDaysLength;
          j++
        ) {
          let prev = this.getPreviousMonthAndYear(month, year);
          week.push({
            day: j,
            month: prev.month,
            year: prev.year,
            otherMonth: true,
            today: this.isToday(today, j, prev.month, prev.year),
            selectable: this.isSelectable(j, prev.month, prev.year)
          });
        }

        let remainingDaysLength = 7 - week.length;
        for (let j = 0; j < remainingDaysLength; j++) {
          week.push({
            day: dayNo,
            month: month,
            year: year,
            today: this.isToday(today, dayNo, month, year),
            selectable: this.isSelectable(dayNo, month, year)
          });
          dayNo++;
        }
      } else {
        for (let j = 0; j < 7; j++) {
          if (dayNo > daysLength) {
            let next = this.getNextMonthAndYear(month, year);
            week.push({
              day: dayNo - daysLength,
              month: next.month,
              year: next.year,
              otherMonth: true,
              today: this.isToday(
                today,
                dayNo - daysLength,
                next.month,
                next.year
              ),
              selectable: this.isSelectable(
                dayNo - daysLength,
                next.month,
                next.year
              )
            });
          } else {
            week.push({
              day: dayNo,
              month: month,
              year: year,
              today: this.isToday(today, dayNo, month, year),
              selectable: this.isSelectable(dayNo, month, year)
            });
          }

          dayNo++;
        }
      }

      this.dates.push(week);
    }
  }

  prevMonth(event) {
    if (this.disabled) {
      event.preventDefault();
      return;
    }

    if (this.currentMonth === 0) {
      this.currentMonth = 11;
      this.currentYear--;
    } else {
      this.currentMonth--;
    }

    this.onMonthChange.emit({
      month: this.currentMonth + 1,
      year: this.currentYear
    });
    this.createMonth(this.currentMonth, this.currentYear);
    event.preventDefault();
  }

  nextMonth(event) {
    if (this.disabled) {
      event.preventDefault();
      return;
    }

    if (this.currentMonth === 11) {
      this.currentMonth = 0;
      this.currentYear++;
    } else {
      this.currentMonth++;
    }

    this.onMonthChange.emit({
      month: this.currentMonth + 1,
      year: this.currentYear
    });
    this.createMonth(this.currentMonth, this.currentYear);
    event.preventDefault();
  }

  prevYear(event) {
    if (this.disabled) {
      event.preventDefault();
      return;
    }

    this.createYear(--this.currentYear);
    event.preventDefault();
  }

  nextYear(event) {
    if (this.disabled) {
      event.preventDefault();
      return;
    }

    this.createYear(++this.currentYear);
    event.preventDefault();
  }

  nextDecade() {
    if (this.disabled) {
      event.preventDefault();
      return;
    }

    this.currentDecadeStart = this.currentDecadeEnd;
    this.currentDecadeEnd = this.currentDecadeEnd + 10;
    this.createDecades();
    event.preventDefault();
  }

  prevDecade() {
    if (this.disabled) {
      event.preventDefault();
      return;
    }

    this.currentDecadeEnd = this.currentDecadeStart;
    this.currentDecadeStart = this.currentDecadeEnd - 10;
    this.createDecades();
    event.preventDefault();
  }

  onMonthSelect(event, month) {
    this.currentMonth = this._locale.monthNamesShort.indexOf(month);
    this.createYear(this.currentYear);
    this.createMonth(this.currentMonth, this.currentYear);
    this.showMonths = false;
    this.showDays = true;
    event.preventDefault();

    this.onMonthChange.emit({
      month: this.currentMonth,
      year: this.currentYear
    });
  }

  onYearSelect(event, year) {
    let prevYear = this.currentYear;
    this.currentYear = year;
    this.showYears = false;
    this.showMonths = true;

    event.preventDefault();

    this.createDecades();
    this.createYear(prevYear);
  }

  onDateSelect(event, dateMeta) {
    this.hideOverlay();
    if (this.disabled || !dateMeta.selectable) {
      event.preventDefault();
      return;
    }
    if (this.isMultipleSelection() && this.isSelected(dateMeta)) {
      this.value = this.value.filter((date, i) => {
        return !this.isDateEquals(date, dateMeta);
      });
      this.onSelect.emit(this.value);
    } else {
      if (this.shouldSelectDate(dateMeta)) {
        if (dateMeta.otherMonth) {
          if (this.selectOtherMonths) {
            this.currentMonth = dateMeta.month;
            this.currentYear = dateMeta.year;
            this.createMonth(this.currentMonth, this.currentYear);
            this.selectDate(dateMeta);
          }
        } else {
          this.selectDate(dateMeta);
        }
      }
    }
    this.updateInputfield();
    event.preventDefault();
  }

  shouldSelectDate(dateMeta) {
    if (this.isMultipleSelection())
      return (
        !this.maxDateCount ||
        !this.value ||
        this.maxDateCount > this.value.length
      );
    else return true;
  }

  updateInputfield() {
    let formattedValue = '';

    if (this.value) {
      if (this.isSingleSelection()) {
        formattedValue = this.formatDateTime(this.value);
      } else if (this.isMultipleSelection()) {
        if(this.showOnlyFirstSelection){
          formattedValue = this.formatDateTime(this.value[0]);
        }else{
        for (let i = 0; i < this.value.length; i++) {
          let dateAsString = this.formatDateTime(this.value[i]);
          formattedValue += dateAsString;
          if (i !== this.value.length - 1) {
            formattedValue += ', ';
          }
        }
      }
      } else if (this.isRangeSelection()) {
        if (this.value && this.value.length) {
          let startDate = this.value[0];
          let endDate = this.value[1];

          formattedValue = this.formatDateTime(startDate);
          if (endDate) {
            formattedValue += ' - ' + this.formatDateTime(endDate);
          }
        }
      }
    }

    this.inputFieldValue = formattedValue;
    this.updateFilledState();
    if (this.inputfieldViewChild && this.inputfieldViewChild.nativeElement) {
      this.inputfieldViewChild.nativeElement.value = this.inputFieldValue;
    }
  }

  formatDateTime(date) {
    let formattedValue = null;
    if (date) {
      formattedValue = this.formatDate(date, this.dateFormat);
    }

    return formattedValue;
  }

  selectDate(dateMeta) {
    let date;
    if (this.utc)
      date = new Date(Date.UTC(dateMeta.year, dateMeta.month, dateMeta.day));
    else date = new Date(dateMeta.year, dateMeta.month, dateMeta.day);

    if (this.minDate && this.minDate > date) {
      date = this.minDate;
    }

    if (this.maxDate && this.maxDate < date) {
      date = this.maxDate;
    }

    if (this.isSingleSelection()) {
      this.updateModel(date);
    } else if (this.isMultipleSelection()) {
      if (this.value && !Array.isArray(this.value)) {
        this.value = [this.value];
      }
      this.updateModel(this.value ? [...this.value, date] : [date]);
    } else if (this.isRangeSelection()) {
      if (this.value && this.value.length) {
        let startDate = this.value[0];
        let endDate = this.value[1];

        if (!endDate && date.getTime() >= startDate.getTime()) {
          endDate = date;
        } else {
          startDate = date;
          endDate = null;
        }

        this.updateModel([startDate, endDate]);
      } else {
        this.updateModel([date, null]);
      }
    }

    this.onSelect.emit(this.value);
  }

  updateModel(value) {
    this.value = value;

    if (this.dataType == 'date') this.onModelChange(this.value);
    else if (this.dataType == 'string')
      this.onModelChange(this.formatDateTime(this.value));
  }

  getFirstDayOfMonthIndex(month: number, year: number) {
    let day = new Date();
    day.setDate(1);
    day.setMonth(month);
    day.setFullYear(year);

    let dayIndex = day.getDay() + this.getSundayIndex();
    return dayIndex >= 7 ? dayIndex - 7 : dayIndex;
  }

  getDaysCountInMonth(month: number, year: number) {
    return 32 - this.daylightSavingAdjust(new Date(year, month, 32)).getDate();
  }

  getDaysCountInPrevMonth(month: number, year: number) {
    let prev = this.getPreviousMonthAndYear(month, year);
    return this.getDaysCountInMonth(prev.month, prev.year);
  }

  getPreviousMonthAndYear(month: number, year: number) {
    let m, y;

    if (month === 0) {
      m = 11;
      y = year - 1;
    } else {
      m = month - 1;
      y = year;
    }

    return { month: m, year: y };
  }

  getNextMonthAndYear(month: number, year: number) {
    let m, y;

    if (month === 11) {
      m = 0;
      y = year + 1;
    } else {
      m = month + 1;
      y = year;
    }

    return { month: m, year: y };
  }

  getSundayIndex() {
    return this.locale.firstDayOfWeek > 0 ? 7 - this.locale.firstDayOfWeek : 0;
  }

  isFirst(dateMeta): boolean {
    if (this.value) {
      if (this.isMultipleSelection()) {
        if (this.differentStyleForMultiple) {
          return this.isDateEquals(this.value[0], dateMeta);
        }
      }
    }
    return true;
  }

  isSelected(dateMeta): boolean {
    if (this.value) {
      if (this.isSingleSelection()) {
        return this.isDateEquals(this.value, dateMeta);
      } else if (this.isMultipleSelection()) {
        let selected = false;
        for (let date of this.value) {
          selected = this.isDateEquals(date, dateMeta);
          if (selected) {
            break;
          }
        }

        return selected;
      } else if (this.isRangeSelection()) {
        if (this.value[1])
          return (
            this.isDateEquals(this.value[0], dateMeta) ||
            this.isDateEquals(this.value[1], dateMeta) ||
            this.isDateBetween(this.value[0], this.value[1], dateMeta)
          );
        else return this.isDateEquals(this.value[0], dateMeta);
      }
    } else return false;
  }

  isDateEquals(value, dateMeta) {
    if (value)
      return (
        value.getDate() === dateMeta.day &&
        value.getMonth() === dateMeta.month &&
        value.getFullYear() === dateMeta.year
      );
    else return false;
  }

  isDateBetween(start, end, dateMeta) {
    let between: boolean = false;
    if (start && end) {
      let date: Date = new Date(dateMeta.year, dateMeta.month, dateMeta.day);
      return (
        start.getTime() <= date.getTime() && end.getTime() >= date.getTime()
      );
    }

    return between;
  }

  isSingleSelection(): boolean {
    return this.selectionMode === 'single';
  }

  isRangeSelection(): boolean {
    return this.selectionMode === 'range';
  }

  isMultipleSelection(): boolean {
    return this.selectionMode === 'multiple';
  }

  isToday(today, day, month, year): boolean {
    return (
      today.getDate() === day &&
      today.getMonth() === month &&
      today.getFullYear() === year
    );
  }

  isSelectable(day, month, year): boolean {
    let validMin = true;
    let validMax = true;
    let validDate = true;
    let validDay = true;

    if (this.minDate) {
      if (this.minDate.getFullYear() > year) {
        validMin = false;
      } else if (this.minDate.getFullYear() === year) {
        if (this.minDate.getMonth() > month) {
          validMin = false;
        } else if (this.minDate.getMonth() === month) {
          if (this.minDate.getDate() > day) {
            validMin = false;
          }
        }
      }
    }

    if (this.maxDate) {
      if (this.maxDate.getFullYear() < year) {
        validMax = false;
      } else if (this.maxDate.getFullYear() === year) {
        if (this.maxDate.getMonth() < month) {
          validMax = false;
        } else if (this.maxDate.getMonth() === month) {
          if (this.maxDate.getDate() < day) {
            validMax = false;
          }
        }
      }
    }

    if (this.disabledDates) {
      validDate = !this.isDateDisabled(day, month, year);
    }

    if (this.disabledDays) {
      validDay = !this.isDayDisabled(day, month, year);
    }

    return validMin && validMax && validDate && validDay;
  }

  isDateDisabled(day: number, month: number, year: number): boolean {
    if (this.disabledDates) {
      for (let disabledDate of this.disabledDates) {
        if (
          disabledDate.getFullYear() === year &&
          disabledDate.getMonth() === month &&
          disabledDate.getDate() === day
        ) {
          return true;
        }
      }
    }

    return false;
  }

  isDayDisabled(day: number, month: number, year: number): boolean {
    if (this.disabledDays) {
      let weekday = new Date(year, month, day);
      let weekdayNumber = weekday.getDay();
      return this.disabledDays.indexOf(weekdayNumber) !== -1;
    }
    return false;
  }

  onInputFocus(event: Event) {
    this.focus = true;
    if (this.showOnFocus) {
      this.showOverlay();
    }
    this.onFocus.emit(event);
  }

  onInputBlur(event: Event) {
    this.focus = false;
    this.onBlur.emit(event);
    this.updateInputfield();
    this.onModelTouched();
  }

  onButtonClick(event, inputfield) {
    if (
      !this.overlayViewChild.nativeElement.offsetParent ||
      this.overlayViewChild.nativeElement.style.display === 'none'
    ) {
      inputfield.focus();
      this.showOverlay();
    } else {
      this.hideOverlay();
    }

    this.datepickerClick = true;
  }

  onInputKeydown(event) {
    this.isKeydown = true;
    if (event.keyCode === 9) {
      this.hideOverlay();
    }
  }

  onUserInput(event) {
    // IE 11 Workaround for input placeholder : https://github.com/primefaces/primeng/issues/2026
    if (!this.isKeydown) {
      return;
    }
    this.isKeydown = false;

    let val = event.target.value;
    try {
      let value = this.parseValueFromString(val);
      this.updateModel(value);
      this.updateUI();
    } catch (err) {
      //invalid date
      this.updateModel(null);
    }

    this.filled = val != null && val.length;
    this.onInput.emit(event);
  }

  parseValueFromString(text: string): Date {
    if (!text || text.trim().length === 0) {
      return null;
    }

    let value: any;

    if (this.isSingleSelection()) {
      value = this.parseDateTime(text);
    } else if (this.isMultipleSelection()) {
      let tokens = text.split(',');
      value = [];
      for (let token of tokens) {
        value.push(this.parseDateTime(token.trim()));
      }
    } else if (this.isRangeSelection()) {
      let tokens = text.split(' - ');
      value = [];
      for (let i = 0; i < tokens.length; i++) {
        value[i] = this.parseDateTime(tokens[i].trim());
      }
    }

    return value;
  }

  parseDateTime(text): Date {
    let date: Date;
    let parts: string[] = text.split(' ');

    date = this.parseDate(text, this.dateFormat);

    return date;
  }

  updateUI() {
    let val = this.value || this.defaultDate || new Date();

    if (Array.isArray(val)) {
      val = val[0];
    }

    this.createMonth(val.getMonth(), val.getFullYear());
  }

  onDatePickerClick(event) {
    this.datepickerClick = true;
  }

  showOverlay() {
    this.overlayVisible = true;
    if (this.autoZIndex) {
      this.overlayViewChild.nativeElement.style.zIndex = String(
        this.baseZIndex + ++rcCalendarZIndex
      );
    }

    this.bindDocumentClickListener();

    if (!this.inline) {
      setTimeout(() => {
        if (this.overlayVisible) {
          this.alignOverlay();
        }
      });
    }
  }

  hideOverlay(event?: Event, emitClose: boolean = false) {
    this.overlayVisible = false;
    this.unbindDocumentClickListener();

    if (emitClose) {
      this.onClose.emit(event);
    }
  }

  alignOverlay() {
    const overlayElement = this.overlayViewChild.nativeElement as HTMLElement;
    const targetElement = this.inputfieldViewChild.nativeElement as HTMLElement;

    if (this.appendTo) {
      this.positionOverlayAbsolute(overlayElement, targetElement);
    } else {
      this.positionOverlayRelative(overlayElement, targetElement);
    }
  }

  private getAppendTarget(): HTMLElement | null {
    if (this.appendTo === 'body') {
      return document.body;
    }

    if (this.appendTo && typeof this.appendTo.appendChild === 'function') {
      return this.appendTo as HTMLElement;
    }

    return null;
  }

  private positionOverlayAbsolute(
    overlayElement: HTMLElement,
    targetElement: HTMLElement
  ) {
    const targetRect = targetElement.getBoundingClientRect();

    overlayElement.style.position = 'absolute';
    overlayElement.style.top = `${targetRect.bottom + window.scrollY}px`;
    overlayElement.style.left = `${targetRect.left + window.scrollX}px`;
    overlayElement.style.minWidth = `${targetRect.width}px`;
  }

  private positionOverlayRelative(
    overlayElement: HTMLElement,
    targetElement: HTMLElement
  ) {
    overlayElement.style.position = 'absolute';
    overlayElement.style.top = `${targetElement.offsetTop + targetElement.offsetHeight}px`;
    overlayElement.style.left = `${targetElement.offsetLeft}px`;
    overlayElement.style.minWidth = `${targetElement.offsetWidth}px`;
  }

  writeValue(value: any): void {
    this.value = value;
    if (this.value && typeof this.value === 'string') {
      this.value = this.parseValueFromString(this.value);
    }

    this.updateInputfield();
    this.updateUI();
  }

  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  // Ported from jquery-ui datepicker formatDate
  formatDate(date, format) {
    if (!date) {
      return '';
    }

    let iFormat;
    const lookAhead = match => {
        const matches =
          iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
        if (matches) {
          iFormat++;
        }
        return matches;
      },
      formatNumber = (match, value, len) => {
        let num = '' + value;
        if (lookAhead(match)) {
          while (num.length < len) {
            num = '0' + num;
          }
        }
        return num;
      },
      formatName = (match, value, shortNames, longNames) => {
        return lookAhead(match) ? longNames[value] : shortNames[value];
      };
    let output = '';
    let literal = false;

    if (date) {
      for (iFormat = 0; iFormat < format.length; iFormat++) {
        if (literal) {
          if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
            literal = false;
          } else {
            output += format.charAt(iFormat);
          }
        } else {
          switch (format.charAt(iFormat)) {
            case 'd':
              output += formatNumber(
                'd',
                this.utc ? date.getUTCDate() : date.getDate(),
                2
              );
              break;
            case 'D':
              output += formatName(
                'D',
                this.utc ? date.getUTCDay() : date.getDay(),
                this.locale.dayNamesShort,
                this.locale.dayNames
              );
              break;
            case 'o':
              if (this.utc) {
                output += formatNumber(
                  'o',
                  Math.round(
                    (new Date(
                      date.getUTCFullYear(),
                      date.getUTCMonth(),
                      date.getUTCDate()
                    ).getTime() -
                      new Date(date.getUTCFullYear(), 0, 0).getTime()) /
                      86400000
                  ),
                  3
                );
              } else {
                output += formatNumber(
                  'o',
                  Math.round(
                    (new Date(
                      date.getFullYear(),
                      date.getMonth(),
                      date.getDate()
                    ).getTime() -
                      new Date(date.getFullYear(), 0, 0).getTime()) /
                      86400000
                  ),
                  3
                );
              }
              break;
            case 'm':
              output += formatNumber(
                'm',
                (this.utc ? date.getUTCMonth() : date.getMonth()) + 1,
                2
              );
              break;
            case 'M':
              output += formatName(
                'M',
                this.utc ? date.getUTCMonth() : date.getMonth(),
                this.locale.monthNamesShort,
                this.locale.monthNames
              );
              break;
            case 'y':
              output += lookAhead('y')
                ? this.utc ? date.getUTCFullYear() : date.getFullYear()
                : ((this.utc ? date.getUTCFullYear() : date.getFullYear()) %
                    100 <
                  10
                    ? '0'
                    : '') +
                  (this.utc ? date.getUTCFullYear() : date.getFullYear()) % 100;
              break;
            case '@':
              output += date.getTime();
              break;
            case '!':
              output += date.getTime() * 10000 + this.ticksTo1970;
              break;
            case "'":
              if (lookAhead("'")) {
                output += "'";
              } else {
                literal = true;
              }
              break;
            default:
              output += format.charAt(iFormat);
          }
        }
      }
    }
    return output;
  }

  // Ported from jquery-ui datepicker parseDate
  parseDate(value, format) {
    if (format == null || value == null) {
      throw 'Invalid arguments';
    }

    value = typeof value === 'object' ? value.toString() : value + '';
    if (value === '') {
      return null;
    }

    let iFormat,
      dim,
      extra,
      iValue = 0,
      shortYearCutoff =
        typeof this.shortYearCutoff !== 'string'
          ? this.shortYearCutoff
          : new Date().getFullYear() % 100 + parseInt(this.shortYearCutoff, 10),
      year = -1,
      month = -1,
      day = -1,
      doy = -1,
      literal = false,
      date,
      lookAhead = match => {
        let matches =
          iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
        if (matches) {
          iFormat++;
        }
        return matches;
      },
      getNumber = match => {
        let isDoubled = lookAhead(match),
          size =
            match === '@'
              ? 14
              : match === '!'
                ? 20
                : match === 'y' && isDoubled ? 4 : match === 'o' ? 3 : 2,
          minSize = match === 'y' ? size : 1,
          digits = new RegExp('^\\d{' + minSize + ',' + size + '}'),
          num = value.substring(iValue).match(digits);
        if (!num) {
          throw 'Missing number at position ' + iValue;
        }
        iValue += num[0].length;
        return parseInt(num[0], 10);
      },
      getName = (match, shortNames, longNames) => {
        let index = -1;
        let arr = lookAhead(match) ? longNames : shortNames;
        let names = [];

        for (let i = 0; i < arr.length; i++) {
          names.push([i, arr[i]]);
        }
        names.sort((a, b) => {
          return -(a[1].length - b[1].length);
        });

        for (let i = 0; i < names.length; i++) {
          let name = names[i][1];
          if (
            value.substr(iValue, name.length).toLowerCase() ===
            name.toLowerCase()
          ) {
            index = names[i][0];
            iValue += name.length;
            break;
          }
        }

        if (index !== -1) {
          return index + 1;
        } else {
          throw 'Unknown name at position ' + iValue;
        }
      },
      checkLiteral = () => {
        if (value.charAt(iValue) !== format.charAt(iFormat)) {
          throw 'Unexpected literal at position ' + iValue;
        }
        iValue++;
      };

    for (iFormat = 0; iFormat < format.length; iFormat++) {
      if (literal) {
        if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
          literal = false;
        } else {
          checkLiteral();
        }
      } else {
        switch (format.charAt(iFormat)) {
          case 'd':
            day = getNumber('d');
            break;
          case 'D':
            getName('D', this.locale.dayNamesShort, this.locale.dayNames);
            break;
          case 'o':
            doy = getNumber('o');
            break;
          case 'm':
            month = getNumber('m');
            break;
          case 'M':
            month = getName(
              'M',
              this.locale.monthNamesShort,
              this.locale.monthNames
            );
            break;
          case 'y':
            year = getNumber('y');
            break;
          case '@':
            date = new Date(getNumber('@'));
            year = date.getFullYear();
            month = date.getMonth() + 1;
            day = date.getDate();
            break;
          case '!':
            date = new Date((getNumber('!') - this.ticksTo1970) / 10000);
            year = date.getFullYear();
            month = date.getMonth() + 1;
            day = date.getDate();
            break;
          case "'":
            if (lookAhead("'")) {
              checkLiteral();
            } else {
              literal = true;
            }
            break;
          default:
            checkLiteral();
        }
      }
    }

    if (iValue < value.length) {
      extra = value.substr(iValue);
      if (!/^\s+/.test(extra)) {
        throw 'Extra/unparsed characters found in date: ' + extra;
      }
    }

    if (year === -1) {
      year = new Date().getFullYear();
    } else if (year < 100) {
      year +=
        new Date().getFullYear() -
        new Date().getFullYear() % 100 +
        (year <= shortYearCutoff ? 0 : -100);
    }

    if (doy > -1) {
      month = 1;
      day = doy;
      do {
        dim = this.getDaysCountInMonth(year, month - 1);
        if (day <= dim) {
          break;
        }
        month++;
        day -= dim;
      } while (true);
    }

    if (this.utc) date = new Date(Date.UTC(year, month - 1, day));
    else date = this.daylightSavingAdjust(new Date(year, month - 1, day));

    if (
      date.getFullYear() !== year ||
      date.getMonth() + 1 !== month ||
      date.getDate() !== day
    ) {
      throw 'Invalid date'; // E.g. 31/02/00
    }
    return date;
  }

  daylightSavingAdjust(date) {
    if (!date) {
      return null;
    }
    date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
    return date;
  }

  updateFilledState() {
    this.filled = this.inputFieldValue && this.inputFieldValue != '';
  }

  onTodayButtonClick(event) {
    let date: Date = new Date();
    let dateMeta = {
      day: date.getDate(),
      month: date.getMonth(),
      year: date.getFullYear(),
      today: true,
      selectable: true
    };

    this.createMonth(dateMeta.month, dateMeta.year);
    this.onDateSelect(event, dateMeta);
    this.onTodayClick.emit(event);
  }

  onClearButtonClick(event) {
    this.updateModel(null);
    this.updateInputfield();
    this.hideOverlay();
    this.onClearClick.emit(event);
  }

  bindDocumentClickListener() {
    if (!this.documentClickListener) {
      this.documentClickListener = this.renderer.listen(
        'document',
        'click',
        event => {
          if (!this.datepickerClick && this.overlayVisible) {
            this.hideOverlay(event, true);
          }

          this.datepickerClick = false;
        }
      );
    }
  }

  unbindDocumentClickListener() {
    if (this.documentClickListener) {
      this.documentClickListener();
      this.documentClickListener = null;
    }
  }

  ngOnDestroy() {
    this.unbindDocumentClickListener();

    if (!this.inline && this.appendTo) {
      this.el.nativeElement.appendChild(this.overlayViewChild.nativeElement);
    }
  }
}
